import React from 'react';
import PropTypes from 'prop-types';

function IimStatusCell({ tdProps, dataItem }) {
  const count = dataItem.unresolvedIssues;
  // eslint-disable-next-line react/jsx-props-no-spreading
  if (!count || count === 0) return <td {...tdProps} />;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <td {...tdProps}>
      <a href={dataItem.unresolvedIssuesPath}>
        <span className="qmb-badge--alert">{count}</span>
      </a>
    </td>
  );
}

IimStatusCell.propTypes = {
  tdProps: PropTypes.object,
  dataItem: PropTypes.shape({
    unresolvedIssues: PropTypes.number,
    unresolvedIssuesPath: PropTypes.string
  }).isRequired
};

IimStatusCell.defaultProps = {
  tdProps: {}
};

export default IimStatusCell;
